import { enqueueSnackbar, VariantType } from 'notistack';
import { StackedSnackbar } from '@/components/ui/StackedSnackbar.tsx';

export default function useSnackbar() {
  const show = ({
    title,
    message,
    variant,
  }: {
    title: string;
    message?: string;
    variant: VariantType;
  }) => {
    enqueueSnackbar(<StackedSnackbar title={title} message={message} />, { variant });
  };

  return { show };
}
